import React from 'react'
import { Pane, Text } from 'evergreen-ui'

const StatusRegister_11 = ({ DataRegister }) => {
  return (
    <Pane>
      <Text
        color="#bb3e03"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
      >
        ไม่ผ่านการคัดเลือก
        {DataRegister[0].QUOTA_NAME +
          " " +
          DataRegister[0].Major1_faculty_name +
          " หลักสูตร " +
          DataRegister[0].Major1_LEVEL_OPEN_NAME +
          " " +
          DataRegister[0].Major1_MAJOR_ID +
          " : " +
          DataRegister[0].Major1_MAJOR_NAME}
      </Text>
    </Pane>
  )
}

export default StatusRegister_11